/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

async function updateCoursePlan(id, body) {
  try {
    const response = await apiClient.put(`/courseplan/${id}`, body);
    const coursePlan = await handleResponse(response);
    return coursePlan;
  } catch (error) {
    return error.response;
  }
}

async function getCoursePlanById(courseplanId) {
  try {
    const response = await apiClient.get(`/courseplan/${courseplanId}`);
    const courseplan = await handleResponse(response);
    return courseplan;
  } catch (error) {
    return error.response;
  }
}

const coursePlanServices = {
  updateCoursePlan,
  getCoursePlanById,
};

export default coursePlanServices;
